<template>
  <div class="lib-detail">
    <div class="lib-detail__body" v-if="dataPageLink && dataPageLink.linkUrl">
      <div class="">
        <!-- <div class="lib-back">
          <a href="javascript:;" @click="$router.go(-1)" class="secondary-color-txt"><i class="fa fa-angle-left"></i> Trở lại</a>
        </div> -->
        <div id="content_viewer" class="inner-img" :class="`inner-type-${dataPageLink.linkUrl ? checkTypeDocs(dataPageLink.linkUrl) : ''}}`">
          <PreviewBookImg
            v-if="dataPageLink && dataPageLink.fileName && dataPageLink.totalPage"
            :fileName="dataPageLink.fileName"
            :totalPage="dataPageLink.totalPage"
            :zoomData="1"
          />
          <PreviewVideo 
            v-else-if="dataPageLink.linkUrl && checkVideo(dataPageLink.linkUrl)"
            :pathView="dataPageLink.linkViewFull ? dataPageLink.pathView : `${appUrl}${dataPageLink.linkUrl}`" 
            
          />
          <PreviewPdf 
            v-else-if="dataPageLink.linkUrl && (checkPdf(dataPageLink.linkUrl) || checkWord(dataPageLink.linkUrl))" 
            :pathView="dataPageLink.linkViewFull ? dataPageLink.pathView : `${appUrl}${dataPageLink.pathView ? dataPageLink.pathView : dataPageLink.linkUrl}`" 
            :zoomData="scale" :class="{'view-default': scale === 1}" 
          />
          <Previewpptx 
            v-else-if="dataPageLink.linkUrl && checkPowerpoint(dataPageLink.linkUrl)" 
            :pathView="dataPageLink.linkViewFull ? dataPageLink.pathView : `${appUrl}${dataPageLink.pathView ? dataPageLink.pathView : dataPageLink.linkUrl}`" 
            :zoomData="scale" 
            :class="{'view-default': scale === 1}" 
          />
          <PreviewImage 
            v-else-if="dataPageLink.linkUrl && checkImage(dataPageLink.linkUrl)" 
            :pathView="dataPageLink.linkViewFull ? dataPageLink.pathView : `${appUrl}${dataPageLink.pathView ? dataPageLink.pathView : dataPageLink.linkUrl}`" 
          />
          <PreviewYoutube 
            v-else-if="dataPageLink.linkUrl && checkYoutube(dataPageLink.linkUrl)" 
            :pathView="dataPageLink.pathView"
            :autoplay="true"
            
          />
          <PreviewAudioPoster
            v-else-if="dataPageLink.linkUrl && checkAudio(dataPageLink.linkUrl)"
            :pathView="dataPageLink.linkViewFull ? dataPageLink.pathView : `${appUrl}${dataPageLink.pathView ? dataPageLink.pathView : dataPageLink.linkUrl}`"
            :autoPlay="true"
            :poster="dataPageLink.posterLink ? `${urlImg}/${dataPageLink.posterLink}` : imgThumbAudio"
          />
          <p v-else class="text-center color-light font-sanpro-semibold">Không tìm thấy tài liệu hiển thị</p>
        </div>
        <div class="lib-detail__content">
          <div class="lib-detail__content__title display-flex-center justify-content-between">
            <h1 class="font-size-24 font-sanpro-semibold primary-color-txt">{{ dataPageLink.title }}</h1>
          </div>
          <div class="lib-detail__content__info">
            <div class="row">
              <div class="col-xl-2 col-lg-4 col-sm-6">
                <label class="secondary-color-txt display-block">Môn:</label>
                <span class="primary-color-txt font-sanpro-light">{{ dataPageLink.subjectName }}</span>
              </div>
              <div class="col-xl-2 col-lg-4 col-sm-6">
                <label class="secondary-color-txt display-block">Sách:</label>
                <span class="primary-color-txt font-sanpro-light">{{ dataPageLink.bookName }}</span>
              </div>
              <div class="col-xl-2 col-lg-4 col-sm-6">
                <label class="secondary-color-txt display-block">Bộ sách:</label>
                <span class="primary-color-txt font-sanpro-light">{{ dataPageLink.bookGroupName }}</span>
              </div>
              <div class="col-xl-2 col-lg-4 col-sm-6">
                <label class="secondary-color-txt display-block">Chương / tuần:</label>
                <span class="primary-color-txt font-sanpro-light">{{ dataPageLink.bookIndexParentName }}</span>
              </div>
              <div class="col-xl-2 col-lg-4 col-sm-6">
                <label class="secondary-color-txt display-block">Bài:</label>
                <span class="primary-color-txt font-sanpro-light">{{ dataPageLink.bookIndexName }}</span>
              </div>
              <div class="col-xl-2 col-lg-4 col-sm-6">
                <label class="secondary-color-txt display-block">Loại học liệu:</label>
                <span class="primary-color font-sanpro-light">
                  {{ dataPageLink.bookPageLinkGroupId === 1 && dataPageLink.isPublish ? 'Học liệu đã được NXBGDVN phê duyệt' : 'Học liệu Hành trang số sản xuất' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PreviewVideo from '@/components/content-files/PreviewVideo.vue'
  import { mapGetters, mapState, mapActions } from 'vuex'
  import { APP_CONFIG } from '@/utils/constants'
  import mixinsFiles from '@/components/content-files/mixinsFiles'
  import PreviewPdf from '@/components/content-files/PreviewPdf.vue'
  import Previewpptx from '@/components/content-files/Previewpptx.vue'
  import PreviewImage from '@/components/content-files/PreviewImage.vue'
  import PreviewYoutube from '@/components/content-files/PreviewYoutube.vue'
  import PreviewAudio from '@/components/content-files/PreviewAudio.vue'
  import PreviewAudioPoster from '@/components/content-files/PreviewAudioPoster.vue'
  import PreviewBookImg from "@/components/content-files/PreviewBookImg.vue";
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import { getMediaDetailInLibs} from './../_api/'
  import IconMedia from './../_components/list/IconMedia.vue'
  import { getAuth } from '@/utils/jwt'
  import ModalReadMoreLinkType from './../_components/list/ModalReadMoreLinkType.vue'
  import ModalShare from '@/modules/libraries/_components/detail/ModalShare.vue'
  import modalShowHelp from '@/components/modal/modalShowHelp'
  const img404 = require(`@/assets/images/img_404.jpg`)
  const imgThumbAudio = require(`@/assets/images/thumb-audio.png`)

  export default {
    name: 'DetailPageLinkLibBook',
    mixins: [ mixinsFiles ],
    components: {
      PreviewVideo,
      PreviewPdf,
      Previewpptx,
      PreviewImage,
      PreviewYoutube,
      PreviewAudio,
      PreviewAudioPoster,
      PreviewBookImg,
      swiper,
      swiperSlide,
      IconMedia,
      ModalReadMoreLinkType,
      ModalShare,
      modalShowHelp
    },
    data () {
      return {
        appUrl: APP_CONFIG.bookCdnUrl,
        cdnUrl: APP_CONFIG.cdnUrl,
        urlImg: APP_CONFIG.urlPlatformCmsImg,
        dataPageLink: {},
        paramSearchRelateMedia: {id: 0, pageIndex: 1, pageSize: 6},
        mediaRelateNotdata: false,
        img404,
        imgThumbAudio,
        authInfo: {},
        openModalReadmore: false,
        thumbnailUrl: '',
        nameRoute: this.$route.name,
        isShowVideo: 3

      }
    },
    methods: {
      getInfoLib(id) {
        let self = this;
        self.setLoading(true);
        // Set relate params: 
        // Get detail
        getMediaDetailInLibs(id).then(res => {
          if(res && res.data) {
            this.dataPageLink = res.data
          }
          
        }).finally(() => self.setLoading(false));
      },

    }
  }
</script>

<style lang="scss" scoped>
  .count-download{
    margin-left: 10px;
  }
  .count-view{
    margin-right: 15px;
  }
  .lib-detail {


    &__content {
      // padding-top: 15px;

      &__read {
        cursor: pointer;

        &:hover {
          @extend .primary-color;
        }
      }

      &__title {
        padding: 20px 0;
      }

      &__info {
        padding: 20px 0 30px;
      }
     
      &__title, &__info {
        border-bottom: 1px solid $color_border_main;
      }

      &__action {
        a {
          letter-spacing: 0.03em;

          &:not(:last-child) {
            margin-right: 15px;
          }
        }
      }
    }

    &__relate {

      &__title {
        margin-bottom: 20px;
      }

      .item {
        
        &__media {
          &:before {
            background: #fff;
          }
        }

        &--lock {
          .item {
            
            &__title {
              @extend .secondary-color-txt;
            }
            // &__icon {
            //   opacity: 1;
            // }
          }
        }

        &__media {
          &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,.2);
            z-index: 1;
            @extend .effect-transition-fast;
            @extend .effect-hide-hover;
          }
        }

        &__icon {
          opacity: 0;
        }

        &:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          pointer-events: none;
        }

        &__body {
          padding: 10px 0;
        }

        p {
          line-height: 1;
        }

        video {
          max-height: 150px;
        }

        video, audio {
          width: 100%;
          pointer-events: none;
        }

        &:hover {
          .item {
            &__icon {
              opacity: 1;
            }

            &__media {
              &:after {
                @extend .effect-show-hover;
              }
            }
          }
        }
      }
    }

    .video-wrap {
      max-width: 100%;
    }

    .swiper-button-prev, .swiper-button-next {
        height: 100%;
        top: 0;
        display: flex;
        align-items: center;
        background-position: center;
        background-color: rgba(255,255,255,.5);
        width: 40px;
    }

    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;

    }
  }
  .lib-back {
    margin-bottom: 15px;
  }
  .audio-detail {
    max-width: 100%;
  }
  @media screen and ( max-width: 767px ) {
    .lib-detail {

      &__content {

        &__title {
          display: block;
        }

        &__action {
          margin-top: 15px;
        }
      }
    }
  }
</style>
